import { PUBLIC_ROUTES } from '../AppRoutes'

export const isPublicRoute = (pathname: string) => {
    return PUBLIC_ROUTES.find(
        (publicRoute) =>
            publicRoute.path.split('/')[0] === pathname.split('/')[1],
    )
}
